export default {
  API_URL: 'https://comet-nabors-api-sandbox.azurewebsites.net/api',
  SANDBOX_URL: 'https://naborssandbox-api.cometrootapp.com'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
